// removed by extract-text-webpack-plugin
module.exports = {"main":"_1hrr0KhCdOT3gmDlCHmb_q","logo":"_1_B-l9jywe5hEFF_8nhtCd","statusIcon":"FidnC7E5ibOTarttDmI-E","isConnected":"_1CUeGR5CEMVnJq3IfLg4wZ","successIcon":"_1ZBS7Y0bfqNp6Tm221OWsg","isErrored":"jI3NaH3I1e-_M-xoVBCH-","errorIcon":"_3iSMudtvEk7mzw0XvT5VrI","dots":"gw3JjwkwUIdaSKV4N2ARf","dot":"OWsDevA_a46AKJz6-CrCG","isConnecting":"_1oB6CSdDCBzex2zzm_R3q8"};


//////////////////
// WEBPACK FOOTER
// ./ui/ConnectingLoader/index.module.css
// module id = 2417
// module chunks = 0